import { render, staticRenderFns } from "./PartySeatsTable.vue?vue&type=template&id=42b902f7&"
import script from "./PartySeatsTable.vue?vue&type=script&lang=js&"
export * from "./PartySeatsTable.vue?vue&type=script&lang=js&"
import style0 from "./PartySeatsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports